// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"b496b470","101":"276f62ea","201":"6c4ac030","207":"877a8b8f","240":"3fa68c83","354":"706ec4dc","488":"e75445ad","499":"6a292a34","589":"310dd687","628":"014075c8","899":"f830399c"}[chunkId] + ".chunk.js";
};